import { brandAsset } from './brandAssets';
import { getPartnerBranding } from './partnerBranding';

function upsertLink(rel: string, href: string, type = 'image/png') {
  const selector = `link[rel="${rel}"]`;
  let link = document.querySelector(selector) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.type = type;
  link.href = href;
}

/** Aplica favicon e ícones PWA do parceiro no <head> (aba do navegador, atalhos, etc.). */
export function applyPartnerBranding(): void {
  const branding = getPartnerBranding();
  if (!branding) return;

  const faviconUrl = brandAsset(branding.favicon);
  upsertLink('icon', faviconUrl);
  upsertLink('shortcut icon', faviconUrl);

  const touchIcon = brandAsset(branding.appleTouchIcon || branding.favicon);
  const appleLinks = document.querySelectorAll('link[rel="apple-touch-icon"]');
  if (appleLinks.length === 0) {
    upsertLink('apple-touch-icon', touchIcon);
  } else {
    appleLinks.forEach((node) => {
      (node as HTMLLinkElement).href = touchIcon;
    });
  }
}
